import React from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react"; // or use heroicons if preferred

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 relative overflow-hidden">
      <div className="max-w-xl text-center px-6">
        {/* 404 Heading */}
        <h1 className="text-9xl font-bold text-gray-800 animate-bounce">404</h1>

        {/* Divider */}
        <div className="w-20 h-1 bg-black mx-auto my-6 rounded" />

        {/* Subheading and message */}
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Oops! Page Not Found</h2>
        <p className="text-gray-600 mb-6">
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </p>

        {/* Back Button */}
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 bg-black text-white px-5 py-2 rounded hover:bg-opacity-90 transition-all shadow"
        >
          <Home className="w-5 h-5" />
          Back to Home
        </button>
      </div>

      {/* Decorative Circles */}
      <div className="absolute w-48 h-48 bg-blue-100 rounded-full top-10 left-10 blur-2xl opacity-40 animate-pulse" />
      <div className="absolute w-32 h-32 bg-purple-100 rounded-full bottom-10 right-10 blur-xl opacity-30 animate-ping" />
      <div className="absolute w-24 h-24 bg-yellow-100 rounded-full top-1/2 right-1/3 blur-md opacity-20" />
    </div>
  );
};

export default NotFound;
